import { render, staticRenderFns } from "./Motivation.vue?vue&type=template&id=8089e308&scoped=true&"
import script from "./Motivation.vue?vue&type=script&lang=js&"
export * from "./Motivation.vue?vue&type=script&lang=js&"
import style0 from "./Motivation.vue?vue&type=style&index=0&id=8089e308&prod&scoped=true&lang=css&"
import style1 from "./Motivation.vue?vue&type=style&index=1&id=8089e308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089e308",
  null
  
)

export default component.exports